import React from 'react';
import RestInputItem from '../../../../components/RestInput/RestInputItem';

const NichesForm = props => (
  <div {...props}>
    <RestInputItem source="name" header="niches.name" />
    <RestInputItem source="description" header="niches.description" />
  </div>
);

NichesForm.propTypes = {};

export default NichesForm;
